import { useMutation, gql } from '@apollo/client';

const useSendReports = (onSuccess = () => {}, onError = () => {}) => {
    return useMutation(
        gql`
            mutation SendReports($file: Upload!) {
                SendReports(file: $file)
            }
        `,
        {
            onCompleted: (res) => {
                onSuccess(res);
            },
            onError
        }
    );
};

export default useSendReports
